import BecomeASellerSec from "./BecomeASeller";

export default BecomeASellerSec;
